import React from "react";
import {
  styled,
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { getStaticFileUrl } from "../utils/config";

// 원본 스타일 유지
const ContactItemWrapper = styled("div")(() => ({
  marginTop: "50px",
  "@media (max-width: 1000px)": {
    marginTop: "30px",
  },
}));

const ContactLabel = styled("div")(() => ({
  marginBottom: "20px",
  paddingLeft: "28px",
  background:
    `url(${getStaticFileUrl('/img/contact/check_icon.png')}) no-repeat left top 4px / 18px`,
  color: "#fff",
  fontSize: "22px",
  fontWeight: 500,
  lineHeight: "26px",

  "@media (max-width: 1000px)": {
    fontSize: "16px",
    lineHeight: "18px",
    backgroundPosition: "left top",
  },
}));

const InpBox = styled("div")(() => ({
  position: "relative",

  '& input[type="text"], & textarea': {
    width: "100%",
    border: "2px solid #2329b6",
    borderRadius: "10px",
    backgroundColor: "#fff",
    fontSize: "16px",
    letterSpacing: "-1px",
    padding: "10px",

    "&::placeholder": {
      color: "#aaadb0",
    },
  },

  '& input[type="text"]': {
    height: "50px",
    padding: "0 19px",
  },
  "& textarea": {
    height: "260px",
    padding: "14px 19px",
    lineHeight: "20px",
    resize: "none",
  },

  "@media (max-width: 1000px)": {
    '& input[type="text"], & textarea': {
      borderRadius: "4px",
      borderColor: "transparent",
    },
    '& input[type="text"]:focus, & textarea:focus': {
      outline: "none",
      borderColor: "#223ada",
    },
  },
}));

// 전화번호 스타일 추가
const NumItem = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "10px",

  "@media (max-width: 1000px)": {
    gap: "4px",
  },
}));

const StyledSelect = styled(Select)(() => ({
  width: "100px",
  height: "50px",
  border: "2px solid #2329b6",
  borderRadius: "10px",
  backgroundColor: "#fff",
  fontSize: "16px",

  "& .MuiSelect-select": {
    padding: "0 10px",
    display: "flex",
    alignItems: "center",
  },

  "&:focus-within": {
    borderColor: "#223ada",
  },

  "@media (max-width: 1000px)": {
    width: "80px",
    borderRadius: "4px",
    borderColor: "transparent",
  },
}));

interface Props {
  label: string;
  value?: string;
  onChange?: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  placeholder?: string;
  isTextarea?: boolean;
  isPhone?: boolean;
  phoneValues?: {
    tel1: string;
    tel2: string;
    tel3: string;
  };
  onPhoneChange?: (key: "tel1" | "tel2" | "tel3", value: string) => void;
}

export const ContactItem: React.FC<Props> = ({
  label,
  value,
  onChange,
  placeholder,
  isTextarea = false,
  isPhone = false,
  phoneValues,
  onPhoneChange,
}) => (
  <ContactItemWrapper>
    <ContactLabel>{label}</ContactLabel>
    <InpBox>
      {isPhone && phoneValues && onPhoneChange ? (
        <NumItem>
          {/* 해결: onChange 이벤트 타입을 명확히 지정하여 TS2345 오류 제거 */}
          <input
            type="text"
            maxLength={4}
            value={phoneValues.tel1}
            onChange={(e) => onPhoneChange("tel1", e.target.value)}
          />
          <input
            type="text"
            maxLength={4}
            value={phoneValues.tel2}
            onChange={(e) => onPhoneChange("tel2", e.target.value)}
          />
          <input
            type="text"
            maxLength={4}
            value={phoneValues.tel3}
            onChange={(e) => onPhoneChange("tel3", e.target.value)}
          />
        </NumItem>
      ) : isTextarea ? (
        <textarea value={value} onChange={onChange} placeholder={placeholder} />
      ) : (
        <input
          type="text"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        />
      )}
    </InpBox>
  </ContactItemWrapper>
);
